import { createFileRoute } from '@tanstack/react-router'
import { SystemSection } from '../../../features/settings/admin-sections'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/system')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'system'),
  component: SystemSection,
})
